import { Collaborators } from './../interfaces/collaborators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";

@Injectable({
	providedIn: 'root'
})
export class CollaboratorsService {

	constructor(private http: HttpClient) { }

	index(
		filters: any, orderBy = '', order = 'asc',
		pageNumber = 1, pageSize = 10): Observable<any> {
		let params = new HttpParams();
		Object.keys(filters).forEach(function (key) {
			params = params.append(key, filters[key]);
		});
		params = params.append('order_by', orderBy);
		params = params.append('order', order);
		params = params.append('page', pageNumber);
		params = params.append('per_page', pageSize);
		return this.http.get(environment.apiUrl + '/collaborator', {
			params: params
		});
	}

	get(id: number): Observable<Object> {
		return this.http.get(environment.apiUrl + '/collaborator/' + id);
	}

	getLogs(uuid:string, page: number, limit: number){
  return this.http.get(environment.apiUrl + `/collaborator/logs?uuid=${uuid}&page=${page}&limit=${limit}`)
	}

	
	storeOrEdit(collaborators: Collaborators): Observable<Object> {
		return collaborators.id ? this.edit(collaborators) : this.store(collaborators);
	}

	store(collaborators: Collaborators): Observable<Object> {
		return this.http.post(environment.apiUrl + '/collaborator/', collaborators);
	}

	edit(collaborators: Collaborators): Observable<Object> {
		return this.http.put(environment.apiUrl + '/collaborator/' + collaborators.id, collaborators);
	}

	destroy(id: number, uuid?: string): Observable<Object> {

		if (uuid) {
			return this.http.delete(environment.apiUrl + '/collaborator/' + id, {
				params: {
					uuid: uuid
				}
			});
		}
		return this.http.delete(environment.apiUrl + '/collaborator/' + id);
	}

}
